<template>
  <v-dialog
    v-model="dialog"
    scrollable
    width="1400"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card>
      <v-card-title>
        Conexiones

        <v-spacer></v-spacer>

        <v-btn icon @click="dialog = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <template v-for="result in orderedResults">
          <div class="mb-3">
            <search-card
              :result="result"
              :search="result.search"
              :score="result.score"
              @dropped="reorderResults"
              disabled
            ></search-card>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SearchCard from "@/components/searches/Card";

export default {
  data: () => ({
    dialog: false,
    orderedResults: []
  }),

  created() {
    this.orderedResults = this.results;
  },

  props: {
    results: {
      required: true,
      type: Array
    }
  },

  components: {
    SearchCard
  },

  methods: {
    reorderResults(id) {
      let item = this.orderedResults.find(el => el.id == id);

      item.dropped = true;

      this.orderedResults = this.orderedResults.sort((a, b) =>
        a === b ? 0 : a ? -1 : 1
      );
    }
  }
};
</script>
